import React, {Component} from 'react';
import {Modal, Table, Alert} from 'react-bootstrap';
import moment from 'moment';
import Button from "../../../../elements/CustomButton/CustomButton";

export default class IncidenceGenerationModal extends Component {

    constructor(props){
        super(props);

        this.state = {};
    }

    render() {

        const incGen = this.props.incidenceGeneration;

        return (
            <div>

                <Modal
                    show={true}
                    onHide={this.props.onHide}
                >
                    <Modal.Header closeButton >
                        <Modal.Title>Generación de incidencias</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>El periodo de generación de incidencias siempre será el mismo que se toma en cuenta para una quincena completa.</p>
                        <Table striped>
                            <tbody>
                            <tr>
                                <td>Generadas el:</td>
                                <td>{moment(incGen.createdDate).format("DD/MM/YYYY")}</td>
                            </tr>
                            <tr>
                                <td>Inicio de periodo:</td>
                                <td>{moment(incGen.fromDate).format("DD/MM/YYYY")}</td>
                            </tr>
                            <tr>
                                <td>Fin de periodo:</td>
                                <td>{moment(incGen.toDate).format("DD/MM/YYYY")}</td>
                            </tr>
                            <tr>
                                <td>Generadas por:</td>
                                <td>{incGen.createdBy? getFullName(incGen.createdBy.employee) : "Generadas por el sistema"}</td>
                            </tr>
                            </tbody>
                        </Table>

                    </Modal.Body>
                    {/*
                    <Modal.Footer>
                        <Button bsStyle="danger" onClick={()=>this.setState({wannaDelete:true})} >Eliminar incidencias</Button>
                    </Modal.Footer>
                    */}
                </Modal>

                <Modal
                    show={this.state.wannaDelete}
                    onHide={()=>this.setState({wannaDelete:false})}
                >
                    <Modal.Header closeButton >
                        <Modal.Title>Elimina registros</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>

                        <p>Vas a eliminar las incidencias del periodo que van del {moment(incGen.fromDate).format("DD/MM/YYYY")} al {moment(incGen.toDate).format("DD/MM/YYYY")}.<br/>
                            Para hacerlo no debe haber una nómina aprobada en esas fechas.<br/>
                        </p>
                        <Alert bsStyle="warning">
                            <b>¡Advertencia!</b> Si alguna de las incidencias generadas aquí fue justificada,
                            se borrará también ese registro y será necesario volverla a justificar en caso de que se vuelva a generar.
                        </Alert>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button bsStyle="danger" onClick={this.props.onIncidenceGenerationDelete}>Sí quiero borrarlas</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

const getFullName = (employee)=>(employee.name+" "+employee.patLastName+" "+employee.matLastName);